var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (myTranslation) {pug_html = pug_html + "\u003Cdiv class=\"btn btn-primary\"\u003E" + (null == (pug_interp = myTranslation("cookie_preferences")) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";}.call(this,"myTranslation" in locals_for_with?locals_for_with.myTranslation:typeof myTranslation!=="undefined"?myTranslation:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src-cookie-manager/views/preferences-button/template.pug
// module id = 409
// module chunks = 0